export default __webpack_public_path__ + "static/media/amparo-arte-4.baa40447.webp";